module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "main",
    attrs: {
      "target": "_blank",
      "to": _vm.linker
    }
  }, [_c('section', {
    class: 'feed box ' + _vm.backgroundColor
  }, [_c('div', {
    staticClass: "feed-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "title is-4"
  }, [_vm._t("header", [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('p', {
    staticClass: "media-content"
  }, [_vm._v("\n            " + _vm._s(_vm.desciption) + "\n          ")]), _vm._v(" "), (_vm.attachment) ? _c('div', {
    staticClass: "cover media-right"
  }, [_c('img', {
    staticClass: "image is-64x64",
    attrs: {
      "src": _vm.attachment
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_vm._v("\n        by "), _c('span', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.author))]), _vm._v("\n        from "), _c('span', {
    staticClass: "board"
  }, [_vm._v(_vm._s(_vm.board))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ea395d54","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Feed.vue
// module id = 258
// module chunks = 1